/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {

// GLOBAL MODAL HANDLER FOR REVIEWS
document.addEventListener('click', function(event) {
 // Open modal when "Read Reviews" is clicked
if (event.target.closest('.read-reviews-text')) {
  const wrapper = event.target.closest('.read-reviews-text');
  const productId = wrapper.getAttribute('data-product-id');
  const modal = document.getElementById('reviews-modal-' + productId);
  if (modal) {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
}
  
  // Close modal when close button is clicked
  if (event.target.closest('.reviews-modal-close')) {
    const closeBtn = event.target.closest('.reviews-modal-close');
    const productId = closeBtn.id.replace('close-reviews-', '');
    const modal = document.getElementById('reviews-modal-' + productId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }
  
  // Close modal when backdrop is clicked
  if (event.target.classList.contains('reviews-modal-backdrop')) {
    const modal = event.target.closest('.reviews-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }
});

// Close modal with Escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const openModals = document.querySelectorAll('.reviews-modal[style*="block"]');
    openModals.forEach(modal => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }
});



  // TOGGLE SOUND ON VIDEO
  document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM Content Loaded - Setting up video toggle");

    // Debug the DOM structure to see what Shopify's video_tag is generating
    const videoWrappers = document.querySelectorAll(".video-autoplay-wrapper");
    console.log("Found", videoWrappers.length, "video wrappers");

    if (videoWrappers.length > 0) {
      // Log the entire HTML structure of the first wrapper to see what we're working with
      console.log("First video wrapper HTML structure:", videoWrappers[0].innerHTML);

      // Attempt to find the video elements using different selectors
      const directVideo = videoWrappers[0].querySelector("video");
      console.log("Direct video element found:", !!directVideo);

      const toggleTargetVideo = videoWrappers[0].querySelector(".video-toggle-target");
      console.log("Toggle target video found:", !!toggleTargetVideo);

      // Try to find all video elements on the page
      const allVideos = document.querySelectorAll("video");
      console.log("Total video elements on page:", allVideos.length);

      // Try to find the toggle button
      const toggleButton = videoWrappers[0].querySelector(".video-sound-toggle");
      console.log("Toggle button found:", !!toggleButton);
    }

    // Set up toggle functionality for all video wrappers
    videoWrappers.forEach(function (wrapper, index) {
      console.log("Setting up video wrapper", index + 1);

      // Try multiple selector strategies to find the video element
      let videoElement = null;

      // Strategy 1: Direct video element
      videoElement = wrapper.querySelector("video");
      if (videoElement) {
        console.log("Found video via direct selector");
      }

      // Strategy 2: Video inside iframe (if Shopify uses iframes)
      if (!videoElement) {
        const iframe = wrapper.querySelector("iframe");
        if (iframe && iframe.contentDocument) {
          videoElement = iframe.contentDocument.querySelector("video");
          if (videoElement) {
            console.log("Found video inside iframe");
          }
        }
      }

      // Strategy 3: Video with specific class
      if (!videoElement) {
        videoElement = wrapper.querySelector(".video-toggle-target");
        if (videoElement) {
          console.log("Found video via class selector");
        }
      }

      // Strategy 4: Last resort - any element with video attributes
      if (!videoElement) {
        const possibleVideos = wrapper.querySelectorAll("[autoplay], [muted], [playsinline]");
        if (possibleVideos.length > 0) {
          videoElement = possibleVideos[0];
          console.log("Found potential video element by attributes");
        }
      }

      const toggleButton = wrapper.querySelector(".video-sound-toggle");

      if (videoElement && toggleButton) {
        console.log("Successfully found video and toggle button, setting up click handler");

        // Make sure the video is actually playing
        videoElement.play().catch((e) => {
          console.error("Could not autoplay video:", e);
          console.log("This might be due to browser autoplay restrictions");
        });

        toggleButton.addEventListener("click", function () {
          console.log("Toggle button clicked");

          // Toggle mute state
          videoElement.muted = !videoElement.muted;
          console.log("Video muted state set to:", videoElement.muted);

          // Toggle icon display
          const volumeOffIcon = toggleButton.querySelector(".icon-volume-off");
          const volumeOnIcon = toggleButton.querySelector(".icon-volume-on");

          if (volumeOffIcon && volumeOnIcon) {
            if (videoElement.muted) {
              volumeOffIcon.style.display = "";
              volumeOnIcon.style.display = "none";
            } else {
              volumeOffIcon.style.display = "none";
              volumeOnIcon.style.display = "";
            }
          } else {
            console.error("Could not find volume icons");
          }
        });
      } else {
        console.error("Could not find video element or toggle button");
        console.log("Video element found:", !!videoElement);
        console.log("Toggle button found:", !!toggleButton);
      }
    });
  });

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener("theme:variant:change", function (event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log("Container ———————— ↓");
  //     console.log(container);
  //     console.log("Variant —————————— ↓");
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener("theme:cart:change", function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log("Cart ———————————— ↓");
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener("theme:cart:init", (e) => {
  //   console.log("theme:cart:init");
  //   console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener("theme:scroll", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:up", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:down", (e) => {
  //   console.log(e);
  // });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener("theme:resize", (e) => {
  //   console.log(e);
  // });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
